module.exports = __webpack_public_path__ + "static/media/28DGC11.f4d1b11e.jpg";